import { render, staticRenderFns } from "./DatosPersonalesFiguraAdicionalex.vue?vue&type=template&id=27031128&lang=html&"
import script from "./DatosPersonalesFiguraAdicionalex.vue?vue&type=script&lang=js&"
export * from "./DatosPersonalesFiguraAdicionalex.vue?vue&type=script&lang=js&"
import style0 from "./DatosPersonalesFiguraAdicionalex.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports